import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../../redux/messages';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getAcademicStory = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_ACADEMIC_STORY,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(iType === 1 ? `/api/app/Formal_Formacion/` : `/api/app/Funcional_Formacion/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: data
    });
    dispatch({
      type: actions.GET_ACADEMIC_STORY,
      payload: {
        academicStory: resp.data.data,
        academicStoryLength: resp.data.count,
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_ACADEMIC_STORY,
      payload: false
    });
  }
}

export const saveAcademicStory = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_ACADEMIC_STORY,
      payload: true
    });
    
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post(iType === 1 ? '/api/app/Formal_Formacion/' : '/api/app/Funcional_Formacion/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    const { academicStory, academicStoryLength } = getState().academicStory;
    const aAcademicStory= [...academicStory, resp.data];
    dispatch({
      type: actions.GET_ACADEMIC_STORY,
      payload: {
        academicStory: aAcademicStory,
        academicStoryLength: academicStoryLength + 1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_ACADEMIC_STORY,
      payload: false
    });
  }
}

export const editAcademicStory = (data, id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_ACADEMIC_STORY,
      payload: true
    });
    
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.put(iType === 1 ? `/api/app/Formal_Formacion/${id}/` : `/api/app/Funcional_Formacion/${id}/`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { academicStory, academicStoryLength } = getState().academicStory;
    academicStory[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_ACADEMIC_STORY,
      payload: {
        academicStory: academicStory,
        academicStoryLength: academicStoryLength
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_ACADEMIC_STORY,
      payload: false
    });
  }
}

export const deleteAcademicStory = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_ACADEMIC_STORY,
      payload: true
    });
    
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    await client.delete(iType === 1 ? `/api/app/Formal_Formacion/${id}/` : `/api/app/Funcional_Formacion/${id}/`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { academicStory, academicStoryLength } = getState().academicStory;
    academicStory.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_ACADEMIC_STORY,
      payload: {
        academicStory: academicStory,
        academicStoryLength: academicStoryLength -1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_ACADEMIC_STORY,
      payload: false
    });
  }
}
